/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl
 */
export interface ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl
     */
    PersonNm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl
     */
    TitleTxt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl
     */
    BusinessNameLine1Txt?: number;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl
     */
    BusinessName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
}

/**
 * Check if a given object implements the ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl interface.
 */
export function instanceOfExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmplFromJSON(json: any): ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl {
    return ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmplFromJSONTyped(json, false);
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmplFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'PersonNm': !exists(json, 'PersonNm') ? undefined : json['PersonNm'],
        'TitleTxt': !exists(json, 'TitleTxt') ? undefined : json['TitleTxt'],
        'BusinessNameLine1Txt': !exists(json, 'BusinessNameLine1Txt') ? undefined : json['BusinessNameLine1Txt'],
        'BusinessName': !exists(json, 'BusinessName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['BusinessName']),
    };
}

export function ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmplToJSON(value?: ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990EZOfficerDirectorTrusteeEmpl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PersonNm': value.PersonNm,
        'TitleTxt': value.TitleTxt,
        'BusinessNameLine1Txt': value.BusinessNameLine1Txt,
        'BusinessName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.BusinessName),
    };
}

